<template>
  <el-main class="layout-main">
    <!-- 内容 -->
    <div class="h100"><router-view /></div>

    <!-- 底部 -->
    <Footers />
  </el-main>
</template>

<script>
import Headers from '../header/header.vue'
import Footers from '../footer/index.vue'
export default {
  name: 'layoutMain',
  components: { Headers, Footers },
  data() {
    return {}
  }
}
</script>
<style scoped></style>
